import Selector from '@/components/ui/selector';
import { useSuspenseQuery } from '@tanstack/react-query';
import { blogFilterQueryOption } from '@/services/queryOptions/blogFilterQueryOption';

interface BlogFiltersProps {
  value: string;
  setSelected: (value: string) => void;
}

export const BlogFilters = ({ setSelected, value }: BlogFiltersProps) => {
  const { data, isError } = useSuspenseQuery(blogFilterQueryOption);
  if (isError) {
    return null;
  }

  const blogFilterItem = [
    { label: 'All categories', value: 'all_categories' },
    ...data.map((filterItem) => ({
      label: filterItem.title,
      value: filterItem.slug,
    })),
  ];

  return (
    <Selector
      items={blogFilterItem}
      onSelect={(option) => {
        setSelected(option.value);
      }}
      selectedValue={value}
    />
  );
};
